import { useSelector } from 'react-redux';

import { ResponseOption } from '@bighealth/types';

import {
  getQuestionResponsesCorrectAnswers,
  getQuestionResponsesQuizAttemptsByPath,
} from 'state/question-response/selectors';

import { getAssessment, QuizAssessment } from './utils/getAssessment';

export type UseQuizForCurrentQuestionReturn = {
  attempts: ResponseOption[][];
  assessment?: QuizAssessment;
};

export const useQuizForCurrentQuestion = (
  name: string
): UseQuizForCurrentQuestionReturn => {
  const attempts = useSelector(getQuestionResponsesQuizAttemptsByPath(name));
  const quizInfo = useSelector(getQuestionResponsesCorrectAnswers)[name];
  const assessment = getAssessment(attempts, quizInfo);
  return { attempts, assessment };
};
